import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const confirmationVisitApi = createApi({
  baseQuery,
  reducerPath: 'ConfirmationVisitApi',
  endpoints: builder => ({
    getConfirmationVisit: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(endPoints.VisitConfirmation.getAllVisit)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getPublishConfirmationVisit: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(endPoints.VisitConfirmation.getPublishVisit)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getConfirmationvisitLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.VisitConfirmation.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createConfirmationvisit: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.VisitConfirmation.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateConfirmationvisit: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.VisitConfirmation.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishConfirmationvisit: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        data,
        publish_doc_version,
        monitoring_visit_id,
        update,
        time_zone_id
      }) => ({
        url: `${formatString(
          endPoints.VisitConfirmation.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&update=${update}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS&time_zone_id=${time_zone_id}&is_published=true`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetConfirmationVisitQuery,
  useLazyGetPublishConfirmationVisitQuery,
  useLazyGetConfirmationvisitLetterQuery,
  useCreateConfirmationvisitMutation,
  useUpdateConfirmationvisitMutation,
  usePublishConfirmationvisitMutation
} = confirmationVisitApi;
